export default {
  title: "Types of booth construction",
  exhibitArea: {
    areaType: "Types of exhibition space",
    closed: "Indoor",
    opened: "Outdoor",
    closedArea: "Indoor space",
    openedArea: "Outdoor space",
    closedAreaDescr:
      "exhibition space situated in the hall of a\n" + "            pavilion.",
    openedAreaDescr: "open air exhibition space.",
    unequipped: "Non-equipped",
    equipped: "Equipped",
    unequippedArea: "Non-equipped space",
    equippedArea: "Equipped space",
    unequippedAreaDescr:
      "indoor or outdoor exhibition space\n" +
      "            without a («only floor»). The participant hires a construction\n" +
      "            company to build the stand.",
    equippedAreaDescr:
      "indoor exhibition space with a booth,\n" +
      "            equipped with the specific set of furniture."
  },
  buildingType: {
    title: "Types of booth construction",
    standart: "Standard",
    standartDescr:
      "Depending on the exhibition, the standard type of booth construction\n" +
      "          differs in both design, configuration and equipment package of the\n" +
      "          stand.",
    exclusive: "Exclusive",
    exclusiveDescr: "Individual, non-standard building on an exclusive project."
  },
  stand: {
    title: "Example of standard booth configuration",
    subtitle:
      "Design and booth equipment package depends on the exact exhibition"
  },
  table: {
    thead1: "Standard booth Package (sq m)",
    thead2: "Unit of measurement",
    tr1thead1: "Storage room",
    tr1thead2: "sqm",
    tr1thead3: "—",
    tr2thead1: "Fascia board",
    tr2thead2: "pcs",
    tr2thead3: "1+1 corner",
    tr2thead4: "1+1 corner",
    tr3thead1: "Lighting of the stand space",
    tr3thead2: "pcs",
    tr3thead3: "1 spot to each 3 sq. m",
    tr4thead1: "Plug socket up to 1 kW",
    tr5thead1: "Information counter h 1.1 m",
    tr6thead1: "Showcase h 2.5 m (1x0,5)",
    tr7thead1: "Витрина высотой 1,1 м (1х0,5)",
    tr8thead1: "Round table D 0.7m, 0.7x0.7m, 1.2x0.7m (to choose)",
    tr9thead1: "Soft chair",
    tr10thead1: "Waste basket",
    tr11thead1: "Clothes rack",
    info1: "Carpet color alternatives: gray, blue, red, green;",
    info2: "Fascia board (one language);"
  },
  addInfo: {
    examples: "Examples of booth construction",
    infotitle: "Important information",
    contactDetailsTitle:
      "Contact details of Constructor General – ExpoConsta Company",
    mainBuilder: "Expocentre's general constructor",
    info1: "Expoconsta OOO",
    info2: "Address: Russia, 123100, Moscow, 1st Krasgvardeysky proezd",
    info3: "Phone:",
    info4: "Fax:",
    info5: "Web:",
    info6:
      "You can see a list of additional stand equipment (ordered and paid separately) in the ",
    info7: "Equipment ",
    info8: "Section here.",
    rulesServiceTitle:
      "Rules for Contractors of Exhibition Stands and Expositions",
    info9:
      "Rules for Contractors of Exhibition Stands and Expositions at Expocentre Fairgrounds",
    info10:
      "In case booth construction is carried out by an exhibitor independently or with the help of construction companies, you should pass the Technical Control in Expoconsta, OOO",
    info11: "Technical Control",
    info12: "Organization which provides fire safety services",
    info13: "The booth project shall be approved by the Fire Inspection",
    info14: "Organization which provides fire safety services",
    info15: "The below documents shall be presented:",
    info16: "Materials list;",
    info17: "Stand Plan;",
    info18:
      "Russian Federation Fire safety Certificates on construction materials;",
    info19:
      "Approval papers on fire protection treatment of flammable materials;",
    info20:
      "Copy of the license of a company made the fire protection treatment;",
    info21:
      "Copies of Certificates for fire safety, compliance, hygienic certificate for fire resistance mixture."
  }
};
